import { useEffect, useMemo, useState } from "react";
import invest from "contracts/Invest";
import { useMoralis } from "react-moralis";

export const useInvestment = () => {
  const { chainId } = useMoralis();
  const [contract, setContract] = useState();

  useEffect(() => {
    setContract(invest);
    return () => {
      setContract(null);
    };
  }, []);

  const isDeployedToActiveChain = useMemo(() => {
    if (!contract?.networks) return undefined;
    return [parseInt(chainId, 16)] in contract.networks;
  }, [contract, chainId]);

  return useMemo(() => {
    if (!isDeployedToActiveChain) return { name: invest.name, address: "", abi: invest.abi };
    return {
      name: invest.name,
      address: contract.networks[parseInt(chainId, 16)]?.["address"] || "",
      abi: invest.abi,
      owner: invest.owner,
      chainId,
    };
  }, [chainId, contract, isDeployedToActiveChain]);
};
